// extracted by mini-css-extract-plugin
export default {"ask-why":"AskWhy_ask-why__NlY3f"};